import { LANDING_ROOT_LINK } from 'constants/links'

export const ATTORNEY_FOR_SHIPMENT_CARGO = '/doc/Доверенность_на_отправку_груза_ЮЛ_бланк_АО_Корса_v1.docx'
export const ATTORNEY_FOR_RECEIVE_CARGO = '/doc/Доверенность_на_получение_груза_ЮЛ_бланк_АО_Корса_v1.docx'
export const PROVISION_OF_FREIGHT_FORWARDING_SERVICES_ACTUAL = `${LANDING_ROOT_LINK}/doc/Договор_на_оказание_транспортно-экспедиционных_услуг_(действует_с_28.01.2025).pdf`
export const CONSEST_DATA_PERSONAL_DOC_ACTUAL = `${LANDING_ROOT_LINK}/doc/Согласие_на_передачу_персональных_данных.pdf`
